// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"canaletic_wrapper__i74rS","links":"canaletic_links__foKFB"};